module.exports = __webpack_public_path__ + "img/CCC-logo.ef58bf9e.svg";